import React from "react";

const OrgNode = ({ node }) => {
    return (
        <div className="flex flex-col items-center bg-white border rounded-lg shadow-md p-4 text-center">
            <div className="w-24 h-24 rounded-full overflow-hidden border-2 border-gray-200">
                <img
                    src={node.photo}
                    alt={node.name}
                    className="object-cover w-full h-full"
                />
            </div>
            <h3 className="text-sm font-semibold mt-2">{node.title}</h3>
            <p className="text-gray-600 text-sm">{node.name}</p>
        </div>
    );
};

export default OrgNode;
